<template>
  <div :key="keyUnico">
    <b-row>
      <b-col sm="3" class="d-none d-lg-block">
        <b-card class="py-2 px-2" no-body>
          <h6 class="text-center ">
            Buscar
          </h6>
          <component :plano="'column'" v-bind:is="componenteBuscador"></component>
        </b-card>
        <!--COMPONENTE FILTRO HOTELES TIENE UN ATRIBUTO v-once, que hace que renderice una sola vez aun asi se hagan modificaciones en su codigo-->
        <FiltroHoteles :data="filtros" v-if="readyFiltro" />
      </b-col>
      <b-col sm="12" lg="9" v-if="sinDispo">
        <v-alert :value="true" type="warning" class="text-center">
          No se encontró disponibilidad, pruebe con diferentes fechas
        </v-alert>
      </b-col>
      <b-col sm="12" lg="9" v-else>
        <component v-bind:is="loadingComponent"></component>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from "vuex"
import Carrito from "@/components/utiles/Carrito.vue"
import FiltroHoteles from "@/components/hoteles/FiltroHoteles.vue"
import LoadingPanelHotel from "@/components/hoteles/LoadingPanelHotel.vue"
import ContenedorRsHotel from "@/components/hoteles/ContenedorRsHotel.vue"
import BuscadorHoteles from "@/components/hoteles/BuscadorHoteles.vue"
import BuscadorTarifario from "@/components/tarifario/BuscadorTarifario.vue"
import { mapMutations } from "vuex"
import moment from "moment"
import TrasladosHandler from "@/assets/js/class/TrasladosHandler.js"
export default {
  name: "resultadoHoteles",
  props: ["data"],
  components: {
    Carrito,
    FiltroHoteles,
    LoadingPanelHotel,
    ContenedorRsHotel,
    BuscadorHoteles,
    BuscadorTarifario
  },
  mounted() {
    this.manejoRsDispoOk(this.data)
  },
  activated() {
    this.$store.dispatch("app/setBuscando", false)
    if (this.mountedExecuted && this.data != undefined) {
      // Para refrescar una busqueda nueva
      this.manejoRsDispoOk(this.data)
    }
    if (this.mountedExecuted && !this._inactive) {
      let boton = this.prepararContinua()
      this.$store.dispatch("carrito/saveBoton", boton)
    }
    this.mountedExecuted = true
  },
  data: function() {
    return {
      uid: null,
      gastos: null,
      readyFiltro: false,
      openModalCarrito: false,
      buscaAdicional: true,
      keyUnico: null,
      mountedExecuted: false,
      filtros: null,
      componenteBuscador: null,
      sinDispo: false
    }
  },
  methods: {
    manejoRsDisponibilidad(rs, status) {
      switch (status) {
        case 200:
          this.estaOkDispo(rs)
          break

        default:
          break
      }
    },
    manejoRsDispoOk(data) {
      try {
        this.$store.dispatch("app/setBuscando", false)
        this.componenteBuscador = data.rs.rq.isTarifario ? "BuscadorTarifario" : "BuscadorHoteles"
        var resultado =
          data.rs.disponibilidad.hoteles.hotel != undefined ? this.toArray(data.rs.disponibilidad.hoteles.hotel) : []
        this.sinDispo = data.rs.disponibilidad.hoteles.hotel === undefined
        const descripciones =
          data.rs.disponibilidad.descripciones != undefined
            ? this.toArray(data.rs.disponibilidad.descripciones.descripcion)
            : []

        const traslados = data.rs.traslados != undefined ? this.toArray(data.rs.traslados) : []
        this.$store.dispatch("adicionales/guardarTrasladosRs", traslados)

        const excursiones = data.rs.excursiones != undefined ? this.toArray(data.rs.excursiones) : []
        this.$store.dispatch("adicionales/guardarExcursiones", excursiones)

        this.$store.dispatch("filtroHoteles/guardarTodosHoteles", {
          todos: [],
          rq: null,
          descripciones: []
        })
        this.$store.dispatch("filtroHoteles/guardarTodosHoteles", {
          todos: resultado,
          rq: data.rs.rq,
          descripciones: descripciones
        })
        this.$store.dispatch("filtroHoteles/setFiltros", data.rs.filtros)
        this.gastos = data.rs.gasto
        this.setValidarSegunBusqueda(false) // No validará que lo que este en el carrito sea lo mismo que se colocó en la busqueda
        this.filtros = data.rs.filtros
        this.readyFiltro = true
        this.setKeyUnico()
      } catch (e) {
        console.log(e)
        this.$router.push({ name: "inicio" })
      }
    },
    estaOkDispo(rs) {
      if (rs.hoteles.hotel === undefined) {
        alert("Redireccionar a Inicio, sin dispo")
        return
      }
      this.manejoRsDispoOk(rs)
    },
    ...mapMutations("carrito", {
      setValidarSegunBusqueda: "setValidarSegunBusqueda"
    }),
    setModal() {
      this.openModalCarrito = !this.openModalCarrito
    },
    validacionSinRsvCupos() {
      if (this.servicios.hoteles.length === 0) {
        return this._$toBotonCarrito("Seleccione al menos un hotel", "adicionalesHoteleria", "primary", true)
      }
      return this._$toBotonCarrito("CONTINUAR", "adicionalesHoteleria", "primary", false)
    },
    setKeyUnico() {
      this.keyUnico = moment().unix()
    },
    prepararContinua() {
      if (!this.segunBusqueda) {
        return this.validacionSinRsvCupos()
      }
      const continua = this.validHab.every(valid => valid.tomado)
      var btnmsg = "¡Faltan por seleccionar!"
      var variant = "orange"
      let disabled = true
      let goto = null
      if (continua) {
        btnmsg = "CONTINUAR"
        variant = "light-blue darken-4"
        goto = "adicionalesHoteleria"
        disabled = false
      }
      return this._$toBotonCarrito(btnmsg, goto, variant, disabled)
    }
  },
  computed: {
    ...mapGetters("carrito", {
      validHab: "getValidHab",
      segunBusqueda: "getValidarSegunBusqueda",
      servicios: "cartServicios"
    }),
    ...mapGetters("filtroHoteles", {
      isFiltrando: "isFiltrando"
    }),
    ...mapGetters("app", {
      isBuscando: "isBuscando"
    }),
    continua: function() {
      if (!this.segunBusqueda) {
        return this.validacionSinRsvCupos()
      }
      const continua = this.validHab.every(valid => valid.tomado)
      var btnmsg = "¡Faltan por seleccionar!"
      var variant = "orange"
      let disabled = true
      let goto = null
      if (continua) {
        btnmsg = "CONTINUAR"
        variant = "light-blue darken-4"
        goto = "adicionalesHoteleria"
        disabled = false
      }
      return this._$toBotonCarrito(btnmsg, goto, variant, disabled)
    },
    loadingComponent: function() {
      let componente = "loadingPanelHotel"
      if (!this.isFiltrando) {
        componente = "contenedorRsHotel"
      }
      return componente
    }
  },
  watch: {
    continua(newCount, oldCount) {
      if (!this._inactive) {
        this.$store.dispatch("carrito/saveBoton", newCount)
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === "buscandox" && !this.isBuscando) {
      this.$router.go(-1)
    }
    next()
  }
}
</script>
<style scoped="">
.badge-as {
  border-radius: 0;
}
</style>
